import { buildUrl, isNonEmptyArray, matchList, ONE_KIBI_BYTE, safeTruncate, tryJsonParse } from '@datadog/browser-core';
/**
 * arbitrary value, byte precision not needed
 */
const GRAPHQL_PAYLOAD_LIMIT = 32 * ONE_KIBI_BYTE;
export function extractGraphQlMetadata(request, graphQlConfig) {
    const metadata = extractGraphQlRequestMetadata(request, graphQlConfig.trackPayload);
    if (!metadata) {
        return;
    }
    if (graphQlConfig.trackResponseErrors && request.responseBody) {
        const responseErrors = parseGraphQlResponse(request.responseBody);
        if (responseErrors) {
            metadata.error_count = responseErrors.length;
            metadata.errors = responseErrors;
        }
    }
    return metadata;
}
export function parseGraphQlResponse(responseText) {
    const response = tryJsonParse(responseText);
    if (!response || typeof response !== 'object') {
        return;
    }
    const responseObj = response;
    if (!isNonEmptyArray(responseObj.errors)) {
        return;
    }
    const errors = responseObj.errors.map((error) => {
        var _a;
        const graphqlError = {
            message: error.message,
            path: error.path,
            locations: error.locations,
            code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code,
        };
        return graphqlError;
    });
    return errors;
}
export function findGraphQlConfiguration(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption) => matchList([graphQlOption.match], url));
}
export function extractGraphQlRequestMetadata(request, trackPayload = false) {
    let rawMetadata;
    if (request.method === 'POST') {
        rawMetadata = extractFromBody(request.requestBody);
    }
    else if (request.method === 'GET') {
        rawMetadata = extractFromUrlQueryParams(request.url);
    }
    if (!rawMetadata) {
        return;
    }
    return sanitizeGraphQlMetadata(rawMetadata, trackPayload);
}
function extractFromBody(requestBody) {
    if (!requestBody || typeof requestBody !== 'string') {
        return;
    }
    const graphqlBody = tryJsonParse(requestBody);
    if (!graphqlBody) {
        return;
    }
    return {
        query: graphqlBody.query,
        operationName: graphqlBody.operationName,
        variables: graphqlBody.variables ? JSON.stringify(graphqlBody.variables) : undefined,
    };
}
function extractFromUrlQueryParams(url) {
    const searchParams = buildUrl(url).searchParams;
    const variablesParam = searchParams.get('variables');
    const variables = variablesParam && tryJsonParse(variablesParam) !== undefined ? variablesParam : undefined;
    return {
        query: searchParams.get('query') || undefined,
        operationName: searchParams.get('operationName') || undefined,
        variables,
    };
}
function sanitizeGraphQlMetadata(rawMetadata, trackPayload) {
    let operationType;
    let payload;
    let variables;
    if (rawMetadata.query) {
        const trimmedQuery = rawMetadata.query.trim();
        operationType = getOperationType(trimmedQuery);
        if (trackPayload) {
            payload = safeTruncate(trimmedQuery, GRAPHQL_PAYLOAD_LIMIT, '...');
        }
    }
    if (rawMetadata.variables) {
        variables = rawMetadata.variables;
    }
    return {
        operationType,
        operationName: rawMetadata.operationName,
        variables,
        payload,
    };
}
function getOperationType(query) {
    var _a;
    return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}
//# sourceMappingURL=graphql.js.map